export default __webpack_public_path__ + "static/media/asesor-estrategico.cf313167.png";